// extracted by mini-css-extract-plugin
module.exports = {"action":"BattlesTable_action__3Vo45"};